import { defineMessages } from 'react-intl'

const translations = defineMessages({
  headline: {
    defaultMessage: 'My Orders',
    id: 'global.account.link.my_orders'
  },
  noOrders: {
    defaultMessage: `You don't have any orders.`,
    id: 'msp.account.order_history.no_orders'
  }
})

export default translations
